document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('variant-selects input:checked').forEach(el => {
    el.checked = false;
  });
});

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('product-form').forEach(formWrapper => {

    const form = formWrapper.querySelector('form');
    const button = formWrapper.querySelector('button[type="submit"]');
    const buttonText = button?.querySelector('[data-hover]');
    const variantInput = form?.querySelector('input[name="id"]');

    if (!form || !button || !buttonText || !variantInput) return;

    // 🔒 INITIAL STATE
    button.disabled = true;
    button.classList.add('disabled');
    buttonText.innerText = 'Select Size';
    buttonText.setAttribute('data-hover', 'Select Size');

    // ❌ Remove any default variant (IMPORTANT)
    variantInput.value = '';

    // 👀 WATCH VARIANT CHANGE (REAL SOURCE OF TRUTH)
    const observer = new MutationObserver(() => {

      const variantId = variantInput.value;

      if (variantId && variantId !== '') {
        // ✅ ENABLE BUTTON
        button.disabled = false;
        button.classList.remove('disabled');

        buttonText.innerText = 'Add to Cart';
        buttonText.setAttribute('data-hover', 'Add to Cart');

      } else {
        // ❌ DISABLE BUTTON
        button.disabled = true;
        button.classList.add('disabled');

        buttonText.innerText = 'Select Size';
        buttonText.setAttribute('data-hover', 'Select Size');
      }

    });

    observer.observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });

  });

});




// bulk buy start

    // document.addEventListener('DOMContentLoaded', function () {
    //   document.querySelectorAll('.variant-pill-form').forEach((form) => {
    //     const pills = form.querySelectorAll('.variant-pill');
    //     const hiddenInput = form.querySelector('.variant-id-input');

    //     pills.forEach((pill) => {
    //       pill.addEventListener('click', function () {
    //         // Remove active class from all pills
    //         pills.forEach((p) => p.classList.remove('active'));

    //         // Add active class to clicked pill
    //         this.classList.add('active');

    //         // Update hidden input with selected variant ID
    //         hiddenInput.value = this.getAttribute('data-variant-id');
    //       });
    //     });
    //   });
    // });



// buy button select size and add to cart function

// (function () {
//   'use strict';

//   const SIZE_OPTION_NAME = 'size';

//   /* ================= GET SIZE ================= */

//   function getSizeFieldset(form) {
//     return [...form.querySelectorAll('variant-selects fieldset')].find(fs =>
//       fs.querySelector('legend')?.textContent.trim().toLowerCase() === SIZE_OPTION_NAME
//     );
//   }

//   function isSizeSelected(form) {
//     return !!getSizeFieldset(form)?.querySelector('input[type="radio"]:checked');
//   }

//   /* ================= BUTTON UPDATE ================= */

//   function updateButton(form) {
//     if (!form) return;

//     const selected = isSizeSelected(form);

//     const btns = form.querySelectorAll('.product-form__submit');

//     btns.forEach(btn => {
//       const label = btn.querySelector('[data-hover]')
//                  || btn.querySelector('span')
//                  || btn;

//       const text = selected ? 'Add to cart' : 'Select size';

//       if (label !== btn) {
//         label.textContent = text;

//         if (label.hasAttribute('data-hover')) {
//           label.setAttribute('data-hover', text);
//         }
//       }

//       btn.disabled = !selected;
//       btn.setAttribute('aria-disabled', String(!selected));
//     });
//   }

//   /* ================= CHANGE EVENT ================= */

//   document.addEventListener('change', function (e) {
//     const input = e.target;

//     if (!input.matches('input[type="radio"]')) return;

//     const form = input.closest('product-form');
//     if (!form) return;

//     const fieldset = input.closest('fieldset');
//     if (!fieldset) return;

//     const legend = fieldset.querySelector('legend')?.textContent.trim().toLowerCase();
//     if (legend !== SIZE_OPTION_NAME) return;

//     // 🔥 ONLY update THIS picker
//     updateButton(form);
//   });

//   /* ================= VARIANT CHANGE (SHOPIFY) ================= */

//   document.addEventListener('variant:changed', function (e) {
//     document.querySelectorAll('product-form').forEach(form => {
//       updateButton(form);
//     });
//   });

//   document.addEventListener('variantChange', function () {
//     document.querySelectorAll('product-form').forEach(form => {
//       updateButton(form);
//     });
//   });

//   /* ================= INIT ================= */

//   function init() {
//     document.querySelectorAll('product-form').forEach(form => {
//       updateButton(form);
//     });
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

// })();


/* ----------------------------- SIZE GUIDE ----------------------------- */
// window.showSizeGuide = id => {
//   document.querySelectorAll(".size2-option").forEach(t => t.classList.remove("active"));
//   document.querySelectorAll(".chart-container").forEach(c => c.classList.remove("active"));
//   document.querySelector(`.size2-option[onclick="showSizeGuide('${id}')"]`)?.classList.add("active");
//   document.getElementById(id)?.classList.add("active");
// };

// window.openSizeBox = () =>
//   document.querySelector(".size-2-body-container")?.classList.add("up");

// window.removeGuide = () =>
//   document.querySelector(".size-2-body-container")?.classList.remove("up");


// discount showing section start

// document.addEventListener("DOMContentLoaded", function () {
//   const btn = document.getElementById("applyBtn");
//   const discountMsg = document.getElementById("discountMsg");

//   btn.addEventListener("click", function () {
//     const productPrice = Number(btn.dataset.price); // like product.price

//     console.log("Product price:", productPrice);

//     if (productPrice >= 2000) {
//       btn.textContent = "Applied";
//       btn.classList.add("evmn-btn-applied");

//       discountMsg.textContent = "First order? Take 10% off";
//       discountMsg.style.color = "";
//     } else {
//       discountMsg.textContent =
//         "this coupon is applicable only on orders worth ₹2000 or more";
//       discountMsg.style.color = "red";
//     }
//   });
// });

// select size oepn box

document.addEventListener('click', function (e) {
  const span = e.target.closest('.evmn-sal-span');
  if (!span) return;

  document.querySelectorAll('.evmn-sal').forEach(el => {
    el.classList.remove('active');
  });

  const next = span.nextElementSibling; // ✅ changed from previousElementSibling

  if (next && next.classList.contains('evmn-sal')) {
    next.classList.add('active');
  }
});

